// Companion CSS files for newComponents used in embeds.
// Imported as raw strings (via ?inline) for Shadow DOM injection.
// If you add new newComponents to embeds, add their companion CSS here.

import buttonCSS from '../newComponents/Button/Button.css?inline'
import formattedMarkdownCSS from '../newComponents/FormattedMarkdown/FormattedMarkdown.css?inline'
import eventAttendeesOverlapCSS from '../newComponents/Event/EventAttendeesOverlap.css?inline'
import dialogCSS from '../newComponents/Dialog/Dialog.css?inline'

// Reset browser default styles for HTML elements that have aggressive UA styles.
// In the main app, React Native Web's class-based resets handle this, but in
// Shadow DOM embeds, elements like <dialog> (used by Tamagui Tooltip.Trigger)
// retain their UA defaults (border, padding, background) because the RNW
// resets only target RNW-generated class names, not element types.
const SHADOW_DOM_ELEMENT_RESET = `
dialog {
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  color: inherit;
  max-width: none;
  max-height: none;
}
`

export const EMBED_COMPONENT_CSS = [
  SHADOW_DOM_ELEMENT_RESET,
  buttonCSS,
  formattedMarkdownCSS,
  eventAttendeesOverlapCSS,
  dialogCSS,
].join('\n')
